import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=0cd39390&scoped=true&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=0cd39390&prod&lang=scss&"
import style1 from "./TipTap.vue?vue&type=style&index=1&id=0cd39390&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd39390",
  null
  
)

export default component.exports